// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ReportByIdPage_wrapper__15GVM","switchWrapper":"ReportByIdPage_switchWrapper__q1xCe","switchLabel":"ReportByIdPage_switchLabel__1Gdp2"};